import { useCallback, useEffect, useRef, useState } from "react";
import api from "../lib/api";
import { RefreshCw } from "lucide-react";

export const useCaptcha = () => {
  const [captcha, setCaptcha] = useState(null);
  const [answer, setAnswer] = useState("");
  const fetchedRef = useRef(false);
  const refresh = useCallback(() => {
    setAnswer("");
    api.get("/auth/captcha").then((r) => setCaptcha(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    if (fetchedRef.current) return;
    fetchedRef.current = true;
    refresh();
  }, [refresh]);
  return { captcha, answer, setAnswer, refresh, payload: { captcha_id: captcha?.captcha_id || "", captcha_answer: answer } };
};

export const CaptchaField = ({ captcha, answer, setAnswer, refresh, testId = "captcha" }) => (
  <div>
    <label className="text-sm font-medium text-neutral-700" data-testid={`${testId}-question`}>{captcha?.question || "Loading security check..."}</label>
    <div className="flex gap-2 mt-1">
      <input data-testid={`${testId}-answer-input`} required value={answer} onChange={(e) => setAnswer(e.target.value)}
        className="flex-1 bg-white border border-neutral-300 rounded-md px-3 py-2 text-sm focus:ring-2 focus:ring-neutral-900 outline-none" placeholder="Your answer" />
      <button type="button" data-testid={`${testId}-refresh-button`} onClick={refresh} title="New question"
        className="px-3 border border-neutral-300 rounded-md text-neutral-500 hover:bg-neutral-50"><RefreshCw size={15} /></button>
    </div>
  </div>
);
